import React, { useState, useEffect } from 'react'
import { Input, Row, Form, Col, notification, Button } from 'antd';
import { useMediaQuery } from 'react-responsive'
import { PlusOutlined } from '@ant-design/icons';
import RequestHandler from '../../util/RequestHandler';

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const ManualTransactionTypeUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(props.Name);

  useEffect(() => {
    setName(props.Name);
  }, [props.Name]);

  const onChange = (e) => {
    setName(e.target.value)
  }

  const onFinishUpdate = values => {
    RequestHandler.put(`/ManualTransactionType`, {
      id: props.manualTransactionTypeId,
      name: values.Name,
    }, false, { rawResponse: true })
    .then(res => {
      if (res.status == 200) {
        openNotificationWithIconUpdate('success');
        setTimeout(function () {
          props.sendDataForUpdate("success");
          setLoading(false);
        }.bind(this), 2000);
      }else{
        setLoading(false)
        }
    }).catch(function (error) {
      setLoading(false);
    });;
  };

  const openNotificationWithIconUpdate = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Güncelleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
        fields={[
          { name: "Name", value: name },
        ]}
      >
        <Row>
          {isDesktopOrLaptop && <>
            <Col span={24}>
              <Form.Item
                name="Name"
                style={{ marginTop: "4%" }}
                label="İşlem Tipi Adı"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Cari Tipi alanını boş bırakmayın.',
                  },
                ]}
              >
                <Input value={name} onChange={onChange} />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Güncelle
                </Button>
              </Form.Item>
            </Col>
          </>}
          {isTabletOrMobileDevice && <>
            <Col span={24}>
              <Form.Item
                name="Name"
                style={{ marginTop: "4%" }}
                label="İşlem Tipi Adı"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Cari Tipi alanını boş bırakmayın.',
                  },
                ]}
              >
                <Input value={name} onChange={onChange} />
              </Form.Item>
            </Col>
            <Col span={10}></Col>
            <Col span={8}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Güncelle
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </>}

        </Row>
      </Form>
    </div>
  )
}
export default ManualTransactionTypeUpdate